import $ from 'jquery';
import { getPropertyHtml } from 'scripts/renderings/property-rendering';
import { propertySearch } from './aktiv-property-search';

let $container = undefined;
let $loadMore = undefined;
let $spinner = undefined;
let $noHits = undefined;
let _searchTerms = undefined;
let _index = 0;
const pageSize = 9;

const beforeSearch = () => {
  $spinner.show();
  $noHits.hide();
  $loadMore.hide();
};

const afterSearch = (showLoadMore) => {
  $spinner.hide();
  if (showLoadMore) {
    $loadMore.show();
  } else {
    $loadMore.hide();
  }
};

export const search = (searchTerms, labels, index) => {
  beforeSearch();
  let useIndex = 0;
  if (Number.isInteger(index)) {
    useIndex = index;
  } else {
    _index = 0;
  }
  let showLoadMore = false;
  propertySearch(searchTerms, useIndex, pageSize).then((p) => {
    for (let i = 0; i < p.Properties.length; i++) {
      const property = getPropertyHtml(labels, p.Properties[i]);
      $container.append(property);
      if (p.Properties[i].Sold) {
        $container.find('article').last().addClass('sold');
      }
    }
    if (p.Properties.length < pageSize) {
      showLoadMore = false;
    } else {
      showLoadMore = true;
    }
  }, () => {
    $noHits.show();
  })
  .always(() => {
    afterSearch(showLoadMore);
  });
};

export const init = (model) => {
  $container = $('#' + model.containerId);
  $loadMore = $('#' + model.loadMoreId);
  $spinner = $('#' + model.spinnerId);
  $noHits = $('#' + model.noHitsId);
  _searchTerms = model.searchTerms;
  search(_searchTerms, model.labels);

  $loadMore.on('click', (e) => {
    e.preventDefault();
    _index = _index + pageSize;
    search(_searchTerms, model.labels, _index);
  });
};
